import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'emotion-theming';
import { Backdrop } from '../../components/Themed.js';
import { getIntakeForms, getCustomFields } from '../../data/app/AppActions.js';
import { getEmployees } from '../../data/employee/EmployeeActions.js';
import {
  setClientInformation,
  setClientChildInformation,
  createClient,
  updateClient,
  getClient,
} from '../../data/client/ClientActions.js';
import {
  getIntakeFields,
  getFamilyMemberTerm,
  getIsServiceAvailableForClient,
} from '../../data/app/AppReducer';
import NewClient from '../../components/new-client/new-client.jsx';
import './ClientForm.css';
import { isLocaleOrCountryInternational } from '../../common/utils.js';

class ClientFormSecondary extends React.Component {
  constructor(props) {
    super(props);

    this.clientSave = this.clientSave.bind(this);
  }

  async componentDidMount() {
    const {
      intakeForms,
      customFields,
      employees,
      getIntakeForms,
      getCustomFields,
    } = this.props;

    if (!intakeForms || !customFields || !employees) {
      await Promise.all([getIntakeForms(), getCustomFields(), getEmployees()]);
    }
  }

  clientSave() {
    const {
      clientInformation,
      updateClient,
      employeeSelection,
      history,
      childrenSelectedForServices,
      companyChildType,
      appLanguage,
    } = this.props;

    clientInformation.companyChildType = companyChildType;
    clientInformation.preferred_language = appLanguage;

    return updateClient(
      clientInformation,
      this.props.hasChildren,
      childrenSelectedForServices
    ).then(res => {
      if (res) {
        if (employeeSelection) {
          history.push('/staffSelection');
        } else {
          history.push('/summary');
        }
      }
    });
  }

  render() {
    const { intakeForms, customFields, appLanguage, locationCountryCode, localeUUID } = this.props;
    const isInternational = isLocaleOrCountryInternational(localeUUID, locationCountryCode)

    let fields = getIntakeFields(intakeForms, customFields, false);

    return (
      <React.Fragment>
        <Backdrop id="backdrop" />
        <div className="scroll-container content-container">
          <div className="page-container">
            <div className="return-client">
              <div className="content-medium">
                {intakeForms && customFields && (
                  <NewClient
                    ifis={fields}
                    appLanguage={appLanguage}
                    mandatoryFields={false}
                    employees={this.props.employees}
                    ui={{ theme_color: this.props.theme.themeColor }}
                    client={this.props.clientInformation}
                    onChange={newClient =>
                      this.props.setClientInformation(newClient)
                    }
                    hasChildren={this.props.hasChildren}
                    children={this.props.clientInformation.children}
                    onChildChange={(newChild, childIndex) =>
                      this.props.setClientChildInformation(newChild, childIndex)
                    }
                    onComplete={this.clientSave}
                    errors={this.props.clientSaveError}
                    clientVariations={this.props.clientVariations}
                    employeeSelection={this.props.employeeSelection}
                    familyMemberTerm={this.props.familyMemberTerm}
                    isServiceAvailableForClient={
                      this.props.isServiceAvailableForClient
                    }
                    hasServicesForClient={this.props.hasServicesForClient}
                    isInternational={isInternational}
                    phoneNumberMandatory={this.props.phoneNumberMandatory}
                    emailMandatory={this.props.emailMandatory}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    isNewClient: state.client.isNewClient,
    hasChildren: state.client.hasChildren,
    hasServicesForClient: state.client.hasServicesForClient,
    clientInformation: state.client.clientInformation,
    clientSaveError: state.client.clientSaveError,
    companyName: state.app.businessInfo.company.name,
    companyChildType: state.app.businessInfo.company.child_type,
    intakeForms: state.app.intakeForms,
    customFields: state.app.customFields,
    employees: state.employee.employees,
    clientVariations: state.client.clientVariations,
    employeeSelection: state.app.businessInfo.company.user_can_select_employee,
    familyMemberTerm: getFamilyMemberTerm(state.app.businessInfo),
    isServiceAvailableForClient: getIsServiceAvailableForClient(
      state.app.businessInfo
    ),
    childrenSelectedForServices: state.client.childrenSelectedForServices,
    localeUUID: state.app.businessInfo.company.locale_uuid,
    phoneNumberMandatory:
      state.app.businessInfo.company.client_must_have_phone_number,
    emailMandatory: state.app.businessInfo.company.client_must_have_email,
    appLanguage: state.app.language,
    locationCountryCode: state.app.businessInfo.company.default_country,
  };
}

export default withRouter(
  withTheme(
    connect(mapStateToProps, {
      getIntakeForms,
      getCustomFields,
      getEmployees,
      setClientInformation,
      setClientChildInformation,
      createClient,
      updateClient,
      getClient,
    })(ClientFormSecondary)
  )
);
